document.documentElement.onclick = closeAll;

function showHide(e, el) {
	var el = el.parentNode;

	if (el.className != "show") {
		e.cancelBubble = true;
		if (e.stopPropagation) e.stopPropagation();
	}
	closeAll();
	el.className = el.className == '' ? 'show' : '';
}

function closeAll() {
	var container = document.getElementById("vlajecky");

	if (container !== null) {
		var items = container.getElementsByTagName("li");

		for (var i = items.length - 1; i >= 0; i--) {
			items[i].className = "";
		}
	}
}

window.showHide = showHide;
window.closeAll = closeAll;